import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BetSlipIcon from 'modules/Common/components/svg/BetSlipIcon';
import {openBetslip, initBetslip} from 'modules/Common/reducers/betslip';
import { isBetSlipEnabled } from 'utils/features';

export class PureBetslipButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
          betSlipEnabled: isBetSlipEnabled()
        }

        this.betSlipButtonClick = this.betSlipButtonClick.bind(this);
    }   

    betSlipButtonClick() {        
        this.props.openBetslip();
    }    

    shouldComponentUpdate(nextProps) {
        if (nextProps.betCount != this.props.betCount) {
            return true;
        }

        return false;
    }

    componentDidMount() {
        if (!this.props.betslipInitialised) {
            this.props.initBetslip();
        }
        
        const betSlipEnabled = isBetSlipEnabled();
        if (betSlipEnabled !== this.state.betSlipEnabled) {
          this.setState({
            betSlipEnabled
          });
        }
    }

    render() {
        if (!this.state.betSlipEnabled) {
          return null;
        }

        return (
            <div className="main-betslip-icon header-action">
                <button onClick={this.betSlipButtonClick}>
                {/* icon-count only for feature integrated-betslip, but no need to call has, because the betCount will be zero */}
                {!!this.props.betCount && <span className="main-betslip-icon-count">{this.props.betCount}</span>}
                <BetSlipIcon/>
                <span>Bet Slip</span>            
                </button>
            </div>
        );
    }

}

PureBetslipButton.propTypes = {
    openBetslip: PropTypes.func.isRequired,
    initBetslip: PropTypes.func.isRequired,
    betCount: PropTypes.number,
    betslipInitialised: PropTypes.bool
}

const mapStateToProps = state => {
    return {
        betCount: state.common.betslip.count,
        betslipInitialised: state.common.betslip.initialised
    }
}

const mapDispatchToProps = dispatch => {
    return {
        openBetslip: () => {
            dispatch(openBetslip())
        },
        initBetslip: () => {
            dispatch(initBetslip())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PureBetslipButton);


// WEBPACK FOOTER //
// ./modules/Common/containers/BetslipButton.js